import { render, staticRenderFns } from "./BoNavLink.vue?vue&type=template&id=195affa2"
import script from "./BoNavLink.vue?vue&type=script&lang=js"
export * from "./BoNavLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports